/* eslint-disable max-len */
export const common = {
  'pd-processing-policy-file-name': 'pd_processing_policy_kg.pdf',
  'user-agreement-sm-podbor-file-name-ru': 'user_agreement_sm_podbor_ky_ru.pdf',
  'user-agreement-sm-podbor-file-name': 'user_agreement_sm_podbor_ky.pdf',
  'accept-agreement-to-continue': 'Улантуу үчүн маалыматыңызды иштетүүгө макулдугуңуз талап кылынат',
  'i-accept-user-data-proccesing': 'Мен жеке маалыматымды иштетүүгө макулдугумду берем',
  yes: 'Ооба',
  no: 'Жок',
  continue: 'Улантуу',
  start: 'Баштоо',
  skip: 'Улантуу',
  delete: 'Өчүрүү',
  cancel: 'Жокко чыгаруу',
  registration: 'Катталуу',
  russia: 'Россия',
  ukraine: 'Украина',
  belarus: 'Беларусь',
  'cookie-agreement': 'Сунуштарыбызды сиздин муктаждыктарыңызга ылайык ыңгайлаштыруу жана сайтты болушунча ыңгайлуу колдоно алышыңыз үчүн cookie-файлдарды колдонобуз. <a href="/user_agreement_sm_podbor_kg.pdf" target="_blank" class="text-neutral-700 hover:underline">Cookie-файлдарды колдонуу тууралуу көбүрөөк маалымат алуу. </a>Сайтты колдонууну улантуу менен, сиз cookie-файлдардын колдонулушуна макул болосуз.',
  'accept-and-close': 'Кабыл алуу жана жабуу',
  'action-confirmation': 'Аракетти ырастоо',
  'execute-action': 'Аракет аткарылсынбы?',
  ok: 'Жарайт',
  'choose-date': 'Күндү тандаңыз',
  'birth-date': 'Туулган күнү',
  'add-resume': 'Резюмеңизди тиркеңиз',
  'invalid-file-type': 'Файлдын түрү жараксыз',
  'cannot-load-stores': 'Дүкөндүн маалыматы жүктөлбөй калды. Администраторлорго кайрылыңыз.',
  'nothing-found': 'Эч нерсе табылган жок',
  'store-business-card': 'Дүкөндүн таанытма картасы',
  'date-time-creation': 'Түзүлгөн күнү/убакыты',
  vacancy: 'Бош орундар',
  store: 'Дүкөн',
  'file-upload-error': 'Файлды жүктөө катасы. Кайра аракет кылыңыз',
  'file-remove-error': 'Файлды өчүрүү катасы. Кайра аракет кылыңыз',
  'file-upload-success': 'Файл ийгиликтүү жүктөлдү',
  'file-remove-success': 'Файл ийгиликтүү өчүрүлдү',
  'file-already-uploaded': 'Бул файлды буга чейин жүктөгөнсүз',
};
